import React from "react";
import moment from "moment";
import { ModalRoute } from "seed/helpers"
import l from "components/util/l";

import WSManager from "components/util/ws";
import ChatForm from "components/presentation/chat/Chat.sub.form.view";
import ChatResult from "components/presentation/chat/Chat.sub.result.view";
import ChatExecution from "components/presentation/chat/Chat.sub.execution.view";
import ChatInput from "components/presentation/chat/Chat.sub.input.view";
import ChatMessage from "components/presentation/chat/Chat.sub.message.view";
import NoteFormCreate from "components/presentation/history/notes/NoteFormCreate";
import IsometricImage from "components/util/helpers/IsometricImage";
import "styles/css/presentation/Chat.css";


const ChatView = ({
  subFormRef,
  chatRef,
  notesRef,
  flow,
  chat,
  processCount,
  collectionCount,
  currentChat,
  chatSettings,
  executionRoomName,
  chatRoomName,
  messages,
  currentMessage,
  botMessage,
  models,
  selectedNote,
  scrollToBtnStatus,
  removePadding,
  showModel,
  showProcesses,
  isExecutionChat,
  isLoading,
  isDeveloper,
  isPreview,
  isCancelable,
  highlightMessage = false,
  onClickRegenerateMessage = () => { },
  onClickRepeatExecution = () => { },
  onClickSuggestion = () => { },
  onClickScrollToBtn = () => { },
  onSendMessage = () => { },
  onClickCancelChatAction = () => { },
  onExecutionMessageReceived = () => { },
  onChatMessageReceived = () => { },
  onChatScroll = () => { },
  onClickTab = () => { },
}) => (
  <div id="chat" className="d-flex justify-content-center w-100 h-100">

    <div className="chat-squares d-flex align-items-end align-items-lg-start">
      <IsometricImage />
    </div>

    <div id="chat-content">
      {
        currentChat && chat && currentChat.id != chat.id &&
        <div className="chat-history-legend d-flex justify-content-center align-items-center 
          animate__animated animate__fadeIn animate__faster">
          <div>
            <i className="fas fa-comment-dots mr-2" />
            Chat {moment(chat.created_at).format("DD MMMM YYYY")}
          </div>
          <div
            role="button"
            className="btn btn-sm btn-link font-italic ml-1 px-2 py-1"
            onClick={() => onClickTab("history", { defaultTab: "chats" })}
          >
            {l("Ver más%GA062")}
          </div>
        </div>
      }

      <div ref={chatRef} className={`chat-messages ${removePadding ? "mx-0 px-0" : ""}`} onScroll={onChatScroll}>
        <div className="chat-messages-wrapper">
          {
            function () {

              return messages.map((message, index) => {

                const nextMessage = messages[index + 1]
                const prevMessage = messages[index - 1]
                const content = message.content;
                const type = message.type;
                const action = message.action;
                const messageSettings = message.settings;

                let suggestions = Object.assign([], message?.messageChatSuggestions ?? []);

                if (messageSettings?.is_result && message.settings.result instanceof Array && message.settings.result.length > 1)
                  return <ChatResult
                    key={index}
                    message={message.settings.message}
                    result={message.settings.result}
                    schema={message.settings.schema}
                  />;

                if (messageSettings?.is_form)
                  return <ChatForm
                    key={index}
                    chatId={chat.id}
                    messageId={message.id}
                    formData={message.settings.data}
                    response={message.settings.form_response}
                  />;

                if (messageSettings?.is_execution_result)
                  return <ChatExecution
                    key={index}
                    executionId={message.settings.execution_id}
                    message={message}
                    isShown={true}
                  />;

                if (content)
                  return <ChatMessage
                    key={index}
                    id={message.id}
                    chat={chat}
                    processCount={processCount}
                    collectionCount={collectionCount}
                    models={models}
                    index={index}
                    type={type}
                    content={content}
                    action={action}
                    prevMessage={prevMessage}
                    nextMessage={nextMessage}
                    suggestions={suggestions}
                    currentMessage={currentMessage}
                    messageSettings={messageSettings}
                    chatSettings={chatSettings}
                    selectedNote={selectedNote}
                    removePadding={removePadding}
                    showModel={showModel}
                    showProcesses={showProcesses}
                    isExecutionChat={isExecutionChat}
                    highlightMessage={highlightMessage && botMessage?.id == message.id}
                    onClickRegenerateMessage={onClickRegenerateMessage}
                    onClickRepeatExecution={onClickRepeatExecution}
                    onClickSuggestion={onClickSuggestion}
                  />;

                return <div key={index}></div>;

              });
            }()
          }
          {isLoading &&
            <div className="loading animate__animated animate__fadeIn animate__faster">
              <div className="loader"></div>
            </div>}
        </div>

      </div>
    </div>

    <div
      id="chat-footer"
      style={{
        width: "calc(100% - 0rem)",
      }}
    >
      <div className="w-100">

        <div className="suggestion-container d-flex align-items-end justify-content-between w-100">
          {/* Temp hide 250828
            !isExecutionChat && prevChat && currentChat.id == chat.id && messages.length == 1 ?
              <button
                type="button"
                className="message resume-chat-btn btn-sm ml-2"
                onClick={onClickResumeChat}>
                <i className="fas fa-history mr-2" />
                {l("Reanudar chat anterior%PA001")}
              </button> : <div />
          */}
          {
            scrollToBtnStatus &&
            <button
              type="button"
              className="scroll-to-btn text-center"
              onClick={onClickScrollToBtn}>
              <i className={"fas " + (scrollToBtnStatus == "TO_TOP" ? "fa-arrow-up" : "fa-arrow-down") + " mr-2"} />
            </button>
          }
        </div>

        <ChatInput
          subFormRef={subFormRef}
          flow={flow}
          chat={chat}
          botMessage={botMessage}
          isLoading={isLoading}
          isCancelable={isCancelable}
          isDeveloper={isDeveloper}
          isExecutionChat={isExecutionChat}
          isPreview={isPreview}
          onSendMessage={onSendMessage}
          onClickCancelChatAction={onClickCancelChatAction}
        />

      </div>
    </div>

    <ModalRoute
      path="/flow_notes/save/:messageId"
      width={800}
      height={800}
      flow={flow}
      refreshNotes={() => notesRef.current?.refreshNotes()}
      component={NoteFormCreate}
    />

    <WSManager
      initialRoom={executionRoomName}
      autoSuscribe={true}
      onMessageReceived={onExecutionMessageReceived}
    />

    <WSManager
      initialRoom={chatRoomName}
      autoSuscribe={true}
      onMessageReceived={onChatMessageReceived}
    />

  </div>
);

export default ChatView;